export const messages = {
  en: {
    editWork: {
      title: 'Edit Work Order',
      workName: 'Title',
      workNamePlaceholder: 'Required, please enter title',
      workType: 'Work Order Type',
      workTypePlaceholder: 'Required, please select work order type',
      processor: 'Processor',
      ccPerson: 'CC Person',
      choose: 'Choose',
      workSign: 'Work Order Sign',
      workSignPlaceholder: 'Required, please select work order sign',
      onceWork: 'One-time Work Order',
      cycleWork: 'Periodic Work Order',
      attachment: 'Attachment',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please enter start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please enter end time',
      period: 'Period',
      periodPlaceholder: 'Required, please select task period',
      monthDay: 'Month/Day',
      byWeek: 'By Week',
      workHours: 'Work Hours',
      workHoursPlaceholder: 'Required, please enter hours',
      hoursComplete: 'hours to complete',
      month: 'Month',
      monthUnit: 'Month',
      day: 'Day',
      dayUnit: 'Day',
      week: 'Week',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      content: 'Content',
      add: 'Add',
      delete: 'Delete'
    },
    uploadFile: {
      upload: 'Upload Attachment',
      sizeLimit: 'File size cannot exceed 20MB',
      success: 'File uploaded successfully',
      failed: 'File upload failed'
    },
    textarea: {
      placeholder: 'Required, please enter content',
      uploadFailed: 'Image upload failed'
    },
  },
  zh: {
    editWork: {
      title: '修改工作单',
      workName: '标题',
      workNamePlaceholder: '必填，请填写标题',
      workType: '工作单类型',
      workTypePlaceholder: '必填，请选择工作单类型',
      processor: '处理人',
      ccPerson: '抄送人',
      choose: '选择',
      workSign: '工作单标识',
      workSignPlaceholder: '必填，请选择工作单标识',
      onceWork: '一次性工单',
      cycleWork: '周期性工单',
      attachment: '附件',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      period: '周期',
      periodPlaceholder: '必填，请选择任务周期',
      monthDay: '月/天',
      byWeek: '按周',
      workHours: '工作单',
      workHoursPlaceholder: '必填，请输入小时数',
      hoursComplete: '小时内完成',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      week: '周',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      content: '内容',
      add: '添加',
      delete: '删除'
    },
    uploadFile: {
      upload: '上传附件',
      sizeLimit: '文件大小不能超过20MB',
      success: '文件上传成功',
      failed: '文件上传失败'
    },
    textarea: {
      placeholder: '必填，请输入内容',
uploadFailed: '图片上传失败'
    },
  },
  'zh-TW': {
    editWork: {
      title: '修改工作單',
      workName: '標題',
      workNamePlaceholder: '必填，請填寫標題',
      workType: '工作單類型',
      workTypePlaceholder: '必填，請選擇工作單類型',
      processor: '處理人',
      ccPerson: '抄送人',
      choose: '選擇',
      workSign: '工作單標識',
      workSignPlaceholder: '必填，請選擇工作單標識',
      onceWork: '一次性工單',
      cycleWork: '周期性工單',
      attachment: '附件',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請填寫開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請填寫結束時間',
      period: '周期',
      periodPlaceholder: '必填，請選擇任務周期',
      monthDay: '月/天',
      byWeek: '按周',
      workHours: '工作單',
      workHoursPlaceholder: '必填，請輸入小時數',
      hoursComplete: '小時內完成',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      week: '周',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      content: '內容',
      add: '添加',
      delete: '刪除'
    },
    uploadFile: {
      upload: '上傳附件',
      sizeLimit: '文件大小不能超過20MB',
      success: '文件上傳成功',
      failed: '文件上傳失敗'
    },
textarea: {
      placeholder: '必填，請輸入內容',
      uploadFailed: '圖片上傳失敗'
    },
  },
  'zh-TW': {
    editWork: {
      title: '修改工作單',
      workName: '標題',
      workNamePlaceholder: '必填，請填寫標題',
      workType: '工作單類型',
      workTypePlaceholder: '必填，請選擇工作單類型',
      processor: '處理人',
      ccPerson: '抄送人',
      choose: '選擇',
      workSign: '工作單標識',
      workSignPlaceholder: '必填，請選擇工作單標識',
      onceWork: '一次性工單',
      cycleWork: '周期性工單',
      attachment: '附件',
      uploadAttachment: '上傳附件',
      content: '工作內容',
      contentPlaceholder: '必填，請填寫工作內容',
      startTime: '開始時間',
      endTime: '結束時間',
      save: '保存',
      go: '前往',
      selectType: '請選擇類型',
      selectProcessor: '請選擇處理人',
      selectTime: '請選擇時間',
      required: '不能為空',
      submitSuccess: '提交成功',
      submitFailed: '提交失敗',
      loadWorkTypeError: '加載工作單類型失敗',
      loadUserError: '加載用戶失敗',
      workflow: '流程',
      workflowName: '流程名稱',
      workflowVersion: '流程版本',
      selectWorkflow: '選擇流程'
    },
    selectStaff: {
      title: '選擇員工',
      searchPlaceholder: '請輸入員工姓名',
      name: '姓名',
      tel: '電話',
      confirm: '確認',
      cancel: '取消'
    },
    selectUser: {
      title: '選擇抄送人',
      searchPlaceholder: '請輸入用戶名稱'
    },
    week: {
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      content: '內容',
      add: '添加',
      delete: '刪除'
    },
    uploadFile: {
      upload: '上傳附件',
      sizeLimit: '文件大小不能超過20MB',
      success: '文件上傳成功',
      failed: '文件上傳失敗'
    },
    textarea: {
      placeholder: '必填，請輸入內容',
      uploadFailed: '圖片上傳失敗'
    },
  }
}